module.exports = "<p>analytics-dashboard works!</p>\n"